import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';

const staticLinks = [
  // 모든 링크는 동적으로만 처리됩니다
];

const MobileOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState(staticLinks);

  useEffect(() => {
    // API 호출하여 테이블 이름 가져오기
    const fetchBoardTables = async () => {
      try {
        const response = await fetch('/request/getBoardTables?category=Order', { 
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();

        // 서버에서 배열을 직접 반환하므로 그대로 사용
        let dynamicLinks = [];
        if (Array.isArray(data)) {
          dynamicLinks = data.map(table => ({
            path: `/Order/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        }
        
        // 정적 링크와 동적 링크 결합
        setLinks([...staticLinks, ...dynamicLinks]);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        setLinks(staticLinks);
      }
    };

    fetchBoardTables();
  }, []);

  useEffect(() => {
    if (links.length > 0) {
      if (location?.state?.fromNavigator === true) {
        navigate(links[0].path);
      }
    }
  }, [location, links, navigate]);

  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="주문 관리"
      backPath="/"
    >
      <Outlet context={{ links }} />
    </MobileSubNavigator>
  );
};

export default MobileOrder;